define('modules/editor/collections/variant_contents',['require','exports','module','backbone','../models/content_page','../models/editorstate'],function(require, exports, module) {
  "use strict";
  var Backbone = require("backbone"),
      ContentPage = require("../models/content_page"),
      EditorState = require("../models/editorstate");

  var Serialization = {
    parse: function(data, options) {
      var collection = _.map(data, function(rawModel, index) {
        var model = {
          step: rawModel.step || index,
          role: Serialization.getRole(rawModel, index, data, options)
        };

        return _.extend(model, rawModel.json, _.pick(rawModel, "id"));
      });

      return module.exports.__super__.parse.call(this, collection, options);
    },

    getRole: function(rawModel, index, data, options) {
      if (rawModel.role) {
        return rawModel.role;
      }

      if (rawModel.json && rawModel.json.role) {
        return rawModel.json.role;
      }

      if (!index) {
        return 'content';
      }

      if (index === data.length -1) {
        return 'confirmation';
      }

      return (options.previousModels[index] &&
        options.previousModels[index].get('role')) || 'step';
    },

    toJSON: function(options) {
      /*return this
        // remember: a model has changed also if its prop groups have changed!!!
        .filter(function(model){ return model.isNew() || model.hasChanged(); })
        .map(function(model){ return model.toJSON(options); });*/
      var content = module.exports.__super__.toJSON.apply(this, arguments),
          toDestroy = _.map(this.stepsToDestroy, function(step) {
            if (!step.isNew()) {
              var json = step.toJSON();
              json._delete = true;
              return json;
            }
          });
      return _.union(_.compact(toDestroy), content);
    }
  };

  module.exports = Backbone.Collection.extend({
    model: ContentPage,
    comparator: "step",
    initialize: function(options) {
      if (!options.services || !options.variant) throw new Error("Services and Variant must be provided");
      this.services = options.services;
      this.variant = options.variant;
      this.on("reset", this._onReset);
      this.on("add", this.setupModel);
      this.on("remove", this._onRemove);
    },

    url: function() {
      return [this.variant.url(), "steps"].join("/");
    },

    _onReset: function(collection) {
      this.each(this.setupModel, this);
    },

    _onRemove: function(model) {
      var step = model.get("step");
      this.stopListening(model);
      EditorState.setCurrentStep(step - 1);
      this.reIndexFrom(step);
      model.services = undefined;
      EditorState.setVariantChanged(true, true);
    },

    reIndexFrom: function(i) {
      this.each(function(model){
        var step = model.get("step");
        if (step > i) model.set("step", step - 1);
      });
    },

    setupModel: function(model) {
      model.services = this.services;
      this._addEventListeners(model);
      this.invoke("setupFormConversion");
    },

    _addEventListeners: function(model){
      this.listenTo(model, "change", function(){
        this.trigger("change");
      }, this.variant);
      this.listenTo(model, "page:change:styles", _.bind(this.variant.trigger, this.variant, "variant:change:styles"));
      this.listenTo(model, "page:change:scripts", _.bind(this.variant.trigger, this.variant, "variant:change:scripts"));
      this.listenTo(model, "page:change:seo", _.bind(this.variant.trigger, this.variant, "variant:change:seo"));
    },

    addStep: function() {
      var step = this.length - 1,
          stepModel = new this.model({
            role: "step",
            step: step
          });
      this.getConfirmation().set("step", this.length);
      return this.add(stepModel);
    },

    addPopup: function() {
      var step = this.length - 1,
          stepModel = new this.model({
            role: "popup",
            step: step
          });
      this.getConfirmation().set("step", this.length);
      return this.add(stepModel);
    },

    removeStep: function(step) {
      step.url = [this.url(), step.id].join("/");
      this.remove(step);
    },

    getConfirmation: function() {
      return this.at(this.length-1);
    },

    getContent: function() {
      return this.at(0);
    },

    getStep: function(n) {
      //if (n >= 1 && n < this.length-1) {
        return this.at(n);
      //}
    },

    parse: Serialization.parse,
    toJSON: Serialization.toJSON,
  });
});

